export enum LocalStorageKey {
    USER_EMAIL_ADDRESS = 'ue',
    AUTH_TOKEN_META = 'auth_token_meta',
    IAM_OBJECT = 'iam_object',
    // USER_NAME = 'un',
    // TEMP_EMAIL = 'te',
    // SOURCE= 'source',
    // REFERRER = 'referrer',
    // LAST_UPDATED_TIME = 'last_updated_time',
}